<template>
<span ref="tippyRef" class="icon suggestion-completed">
    <FaLayers fixedWidth>
        <FaIcon
            icon="trophy"
            :transform="isConfirmed ? 'grow-2' : ''"/>
        <FaIcon
            v-show="isConfirmed"
            icon="star"
            transform="up-4 shrink-9"/>
    </FaLayers>
    <div v-show="false"><!-- Hide tippy initially -->
        <div class="completed-tippy" ref="tippyContent">
            <div>{{ completedText }}</div>
            <button
                v-if="canConfirm"
                @click="confirmCompletion"
                :class="{ 'is-loading': isLoading }"
                class="button is-small is-success is-fullwidth">
                Confirm Completion
            </button>
            <div v-else-if="isConfirmed">
                {{ originalPosterName }} confirmed completion!
            </div>
        </div>
    </div>
</span>
</template>

<script>
import { mapGetters } from 'vuex'

import { defaultDateFormat } from '@/utils'
import tippy from '@/tippy'

export default {
    name: 'SuggestionCompleted',
    props: {
        suggestion: Object,
        isBroadcaster: Boolean,
    },
    data: () => ({
        isLoading: false,
    }),
    computed: {
        ...mapGetters(['channelName', 'userId']),
        completedText: vm => {
            const dateStr = defaultDateFormat(vm.suggestion.completedAt)
            return `${vm.channelName} completed this on ${dateStr}`
        },
        // Don't let the broadcaster confirm completion, it looks weird.
        // Confirming completion is meant to be done by another user, to
        // keep the broadcaster "honest".
        canConfirm: vm => {
            return vm.isOriginalPoster && !vm.isBroadcaster && !vm.isConfirmed
        },
        isConfirmed: vm => !!vm.suggestion.completionConfirmedAt,
        originalPosterName: vm => vm.suggestion.user.name,
        isOriginalPoster: vm => vm.userId === vm.suggestion.user.id,
    },
    mounted () {
        const $refs = this.$refs
        const tippyInstance = tippy($refs.tippyRef, {
            content: ref => $refs.tippyContent,
            // OP must confirm inside the tippy.
            interactive: this.isOriginalPoster,
            appendTo: this.$el,
            //hideOnClick: false,
            //trigger: 'click', // DEBUG ONLY
        })

        this.$once('hook:destroyed', () => {
            tippyInstance.destroy()
        })
    },
    methods: {
        async confirmCompletion () {
            try {
                this.isLoading = true
                const payload = { id: this.suggestion.id }
                await this.$store.dispatch('confirmCompletion', payload)
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>

<style lang="scss">
.suggestion-completed {
    .tippy-box {
        overflow-wrap: break-word;
    }
}
</style>

<style lang="scss" scoped>
.fa-trophy {
    color: $yellow; // bulma var
}
.fa-star {
    color: #fffdf9;
}

.completed-tippy {
    text-align: center;
    > *:not(:last-child) {
        margin-bottom: 0.35rem;
    }
}

</style>
